<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">消息管理</div>
          <span class="m-title-s">对app系统消息进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-search-wrap">
        <el-form :inline="true" :model="searchForm" ref="searchForm">
          <el-form-item label="消息标题:">
            <el-input type="text" size="medium" v-model="searchForm.newsTitle"  placeholder="搜索消息标题" />
          </el-form-item>
          <el-form-item style="margin-left: 30px;">
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" plain @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>消息列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增消息</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="消息名称" width="220"></el-table-column>
          <el-table-column prop="explain" label="消息说明"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id, scope.row.title)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="800px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="消息标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入消息标题"></el-input>
            </el-form-item>
            <el-form-item label="消息说明: " prop="explain">
              <el-input v-model="form.explain" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
            <el-form-item label="消息内容: " prop="content">
<!--              <el-input v-model="form.content" type="textarea" :rows="2" placeholder="输入内容"></el-input>-->
              <div style="height: 600px;width: 500px;">
                <quill-editor
                  style="height: 450px"
                  class="editer"
                  v-model="form.content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @ready="onEditorReady($event)">
                </quill-editor>
              </div>
            </el-form-item>
            <el-form-item label="消息图标: " prop="icon">
              <el-input v-model="form.icon" placeholder="输入消息图标"></el-input>
            </el-form-item>
            <el-form-item label="备用url: " prop="url">
              <el-input v-model="form.url" placeholder="输入备用url"></el-input>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  components: { // 使用编辑器
    quillEditor
  },
  name: 'newsData',
  data () {
    return {
      openText: '新增消息',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      searchForm: {
        newsTitle: '',
        pageNo: 1
      },
      total: 0,
      form: {
        id: '',
        title: '',
        explain: '',
        content: '',
        url: '',
        icon: '',
        createDate: '',
        updateDate: '',
        remarks: ''
      },
      editorOption: {},
      rules: {
        title: [
          { required: true, message: '请输入消息标题', trigger: 'blur' }
        ],
        explain: [
          { required: true, message: '请输入消息说明', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入消息内容', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请输入消息图标', trigger: 'blur' }
        ]
      }
    }
  },
  editor () {
    return this.$refs.myQuillEditor.quill
  },
  methods: {
    onEditorReady (editor) {
      console.log(editor)
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        explain: '',
        content: '',
        url: '',
        icon: '',
        createDate: '',
        updateDate: '',
        remarks: ''
      }
      this.openText = '新增消息'
      this.openState = false
      this.formLoading = false
    },
    search () {
      this.searchForm.pageNo = 1
      this.listData()
    },
    resetForm () {
      this.searchForm = {
        newsTitle: '',
        pageNo: 1
      }
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/app/news/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id, title) {
      let _this = this
      this.$messageBox.confirm('此操作将删除[' + title + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/app/news/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (row) {
      this.openText = '编辑消息'
      this.form = row
      this.openState = true
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/app/news/list', this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/NewsData.vue